import React from "react";

export default class CourseListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openCourses: [],
    };

    this.onToggle = this.onToggle.bind(this);
  }

  render() {
    var self = this;

    // console.log('CourseListView', this.props);

    var courses = this.props.courses.map(function (course) {
      return self.renderCourse(course);
    });

    return (
      <div className="CourseListView">
        <div ref="courses">{courses}</div>
      </div>
    );
  }

  renderArticle(article) {
    return (
      <a key={article.id} href={article.path} className="Article">
        <span className="position">
          {article.position -
            (this.props.suppress_intros_and_summaries ? 1 : 0)}
        </span>{" "}
        &nbsp; <span dangerouslySetInnerHTML={{ __html: article.name }}></span>
        {article.subtype === "image" ? (
          <img className="ImagePreview" src={article.image_preview_path} />
        ) : null}
      </a>
    );
  }

  renderCourse(course) {
    var self = this;

    var courseArticles = course.articles.slice();

    if (self.props.suppress_intros_and_summaries) {
      courseArticles.shift();
      courseArticles.pop();
    }

    var articles = courseArticles.map(function (article) {
      return self.renderArticle(article);
    });

    return (
      <div
        key={course.id}
        className={
          "Course " +
          (this.state.openCourses.indexOf(course.id) >= 0 ? "expanded" : "")
        }
      >
        <div className="CourseNameWrapper">
          <a href={this.props.path} className="preview-image article-anchor">
            <img
              src={course.image_preview_path}
              className="article-anchor"
              alt={"Image for " + course.name}
            />
          </a>
          <div className="NameArticleCountWrapper">
            <a
              href={course.path}
              className="Name"
              dangerouslySetInnerHTML={{ __html: course.name }}
            ></a>
            <div className="ArticleCount">{courseArticles.length} articles</div>
          </div>
          <div className="Buttons">
            <div
              className="chevron-wrapper"
              onClick={this.onToggle.bind(self, course.id)}
            >
              <div
                className={
                  "chevron " +
                  (this.state.openCourses.indexOf(course.id) >= 0
                    ? "down"
                    : "right")
                }
              ></div>
            </div>
          </div>
        </div>
        <div
          className={
            "Articles " +
            (this.state.openCourses.indexOf(course.id) >= 0
              ? "ArticlesOpen"
              : "")
          }
        >
          {articles}
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onToggle(course_id) {
    var openCourses = this.state.openCourses.slice();

    if (openCourses.indexOf(course_id) >= 0) {
      var index = openCourses.indexOf(course_id);
      if (index > -1) {
        openCourses.splice(index, 1);
      }
    } else {
      openCourses.push(course_id);
    }

    this.setState({ openCourses: openCourses });
  }

  /**
   * Helper functions
   */

  toggleActiveArticles(animate) {
    var $courses = $(this.refs.courses);

    if (animate) {
      $courses.find(".Articles").not(".ArticlesOpen").slideUp("fast");
      $courses.find(".ArticlesOpen").slideDown("fast");
    } else {
      $courses.find(".ArticlesOpen").show();
      $courses.find(".Articles").not(".ArticlesOpen").hide();
    }
  }
}
